
module.exports = function (fox, staticUrl) {
	if (staticUrl) {
		__webpack_public_path__ = __webpack_public_path__.replace(/^.*?\/dist\/+/, staticUrl + (staticUrl.slice(-1) === '/' ? '' : '/'));
	}

	require("../../../common/frame/__main_entry.tmp.js")(fox);

	function getDeps (context) {
		context.keys().forEach(function (m) {
			var module = context(m);
			if (typeof module === "function") {
				module(fox, __webpack_require__.p);
			}
		});
	}
	
	var contexts = [];

	contexts.push(require.context("./css", true, /(\/|\\)(?!_)[\w\.\-\\]+\.css$/));

	contexts.push(require.context("./dependencies", true, /(\/|\\)(?!_)[\w\.\-\\]+\.js$/));

	contexts.push(require.context("./options", true, /(\/|\\)(?!_)[\w\.\-\\]+\.(opt|js)$/));

	contexts.push(require.context("fox-dynamic-injection!fox-template-loader?interpolate!./templates", true, /(\/|\\)(?!_)[\w\.\-\\]+\.tpl$/));

	contexts.push(require.context("./widget", true, /(\/|\\)(?!_)[\w\.\-\\]+\.js$/));


	contexts.forEach(getDeps);
};


//////////////////
// WEBPACK FOOTER
// ../common/__main_entry.tmp.js
// module id = 76
// module chunks = 2